// extracted by mini-css-extract-plugin
export default {"wrapper":"ToastShelf_wrapper__Y+F4F","toastWrapper":"ToastShelf_toastWrapper__mgA08","toast":"ToastShelf_toast__996ma"};